import { environment } from '@app-environments/environment';

export const APIs = {
	named_reports: `${environment.serverUrl}/api/named-reports`,
	login_with_token: `${environment.serverUrl}/api/login_with_token`,
	login: `${environment.serverUrl}/api/auth/login`,
	switchUser: `${environment.serverUrl}/api/auth/switch-user`,
	auth_register: `${environment.serverUrl}/api/auth/register`,
	auth_update: `${environment.serverUrl}/api/auth/update`,
	auth_password_change: `${environment.serverUrl}/api/auth/password/change`,
	auth_email_resend: `${environment.serverUrl}/api/auth/email/resend`,
	auth_request_password: `${environment.serverUrl}/api/auth/resetpassword`,
	auth_verify_code: `${environment.serverUrl}/api/auth/verify_code`,
	auth_restore_password: `${environment.serverUrl}/api/auth/restore-passowrd`,
	auth_verify_session: `${environment.serverUrl}/api/auth/verify-session`,
	user_info: environment.serverUrl + 'api/userinfo',
	crm_users: `${environment.serverUrl}/api/crm/users`,
	crm_user_roles: `${environment.serverUrl}/api/crm/user_roles`,
	crm_chat: `${environment.serverUrl}/api/crm/chat`,
	admin_om_chat: `${environment.serverUrl}/api/crm/admin_om_chat`,
	crm_trainings: `${environment.serverUrl}/api/crm/trainings`,
	crm_training_quizzes: `${environment.serverUrl}/api/crm/training/quizzes`,
	crm_training_quizzes_with_questions: `${environment.serverUrl}/api/crm/training/quizzes_with_questions`,
	crm_training_quiz_questions: `${environment.serverUrl}/api/crm/training/quizzes/questions`,
	crm_training_quiz_questions_update: `${environment.serverUrl}/api/crm/training/quizzes/update_questions`,
	crm_communities: `${environment.serverUrl}/api/crm/communities`,
	crm_languages: `${environment.serverUrl}/api/crm/languages`,
	crm_translation: `${environment.serverUrl}/api/crm/languages/crmTranslation`,
	crm_lists: `${environment.serverUrl}/api/crm/lists`,
	crm_suggested_responses: `${environment.serverUrl}/api/crm/suggested_responses`,
	crm_suggested_response_reviews: `${environment.serverUrl}/api/crm/suggested_response_reviews`,
	crm_groups: `${environment.serverUrl}/api/crm/groups`,
	crm_group_chat: `${environment.serverUrl}/api/crm/group-chat`,
	admin_group_chat: `${environment.serverUrl}/api/crm/admin_group_chat`,
	crm_forms: `${environment.serverUrl}/api/crm/forms`,
	crm_form_categories: `${environment.serverUrl}/api/crm/form_categories`,
	crm_reports: `${environment.serverUrl}/api/crm/reports`,
	reports: `${environment.serverUrl}/api/reports`,
	crm_file_upload: `${environment.serverUrl}/api/crm/file_upload`,
	users: `${environment.serverUrl}/api/users`,
	user_deactivated: `${environment.serverUrl}/api/users/deactivated`,
	user_applications: `${environment.serverUrl}/api/user_applications`,
	user_community_assignations: `${environment.serverUrl}/api/user_community_assignations`,
	seekers: `${environment.serverUrl}/api/seekers`,
	seekers_pool: `${environment.serverUrl}/api/seekers/seeker_pool`,
	users_notes: `${environment.serverUrl}/api/notes`,
	users_profile_notes: `${environment.serverUrl}/api/user_profile_notes`,
	stories: `${environment.serverUrl}/api/stories`,
	conversations: `${environment.serverUrl}/api/conversations`,
	conversation_messages: `${environment.serverUrl}/api/conversation_messages`,
	widget_requests: `${environment.serverUrl}/api/widget_requests`,
	vacation_scheduling: `${environment.serverUrl}/api/vacation_scheduling`,
	crm_settings: `${environment.serverUrl}/api/crm_settings`,
	conversation_categories: `${environment.serverUrl}/api/conversation_categories`,
	overflow_categories: `${environment.serverUrl}/api/conversation_categories/overflow`,
	assign_categories: `${environment.serverUrl}/api/conversation_categories/assign_category`,
	notification: `${environment.serverUrl}/api/notification`,
	crmtags: `${environment.serverUrl}/api/tags`,
	suggestedcategories: `${environment.serverUrl}/api/suggested_response_categories`,
	suggestedculture: `${environment.serverUrl}/api/suggested_response_culture`,
	trigers: `${environment.serverUrl}/api/notification`,
	oms: `${environment.serverUrl}/api/users/getoms`,
	crmusers: `${environment.serverUrl}/api/users/getcrmusers`,
	abusive: `${environment.serverUrl}/api/seekers`,
	training_community: `${environment.serverUrl}/api/training_community`,
	automatic_response: `${environment.serverUrl}/api/automatic_response`,
	trainee_management: `${environment.serverUrl}/api/users/trainees`,
	reactivations: `${environment.serverUrl}/api/users/reactivations`,
	placeOmsInBulk: `${environment.serverUrl}/api/users/placeOmsInBulk`,
	placeOmsOneByOne: `${environment.serverUrl}/api/users/placeInTrainingCommunity`,
	placeOmsOneByOneStatusWithdrawn: `${environment.serverUrl}/api/users/deactivateWithdrawnUsers`,
	placeOmsOneByOneStatusFailed: `${environment.serverUrl}/api/users/deactivateFailedUsers`,
	getTraineesReadyForPlacement: `${environment.serverUrl}/api/users/trainees/getReadyForPlacement`,
	getTraineesWithdrawn: `${environment.serverUrl}/api/users/trainees/withdrawnTrainees`,
	getTraineesFailed: `${environment.serverUrl}/api/users/trainees/failedTrainees`
};
